export default "__VITE_ASSET__21be2ee0__"